import ApiService from "@/core/services/api/v2/api.service";

const PROVINCE_LIST_KEY = "ProvinceList";

const ProvinceService = {
  listAll() {
    return new Promise(resolve => {
      // This list is widely used and changes rarely, so cache its values
      let cachedList = window.sessionStorage.getItem(PROVINCE_LIST_KEY);
      if (cachedList) {
        resolve(JSON.parse(cachedList));
      } else {
        ApiService.get("province")
          .then(response => {
            let newList = response.data.response.Provinces;

            window.sessionStorage.setItem(
              PROVINCE_LIST_KEY,
              JSON.stringify(newList)
            );

            resolve(newList);
          })
          .catch(() => {
            resolve([]);
          });
      }
    });
  }
};

export default ProvinceService;
